// In this file, we could use to write application roles related configuration details
import _ from "lodash";
/**
 * All the actions of application
 */
export const actionsList = {
  create: {
    label: {"en":"Create", "ar":"إنشاء"},
    name: "create"
  },
  view: {
    label: {"en":"View", "ar":"رأي"},
    name: "view"
  },
  edit: {
    label: {"en":"Edit", "ar":"تعديل"},
    name: "edit"
  },
  delete: {
    label: {"en":"Delete", "ar":"حذف"},
    name: "delete"
  },
  assign: {
    label:{"en": "Assign", "ar":"تعيين"},
    name: "assign"
  }
};



/**
 * Form the action array of object
 *
 * @param array | string
 * @return array
 */
export const getActions = actions => {
  const setActions = [];

  if (_.isArray(actions) && !_.isEmpty(actions)) {
    actions.forEach(action => {
      if (_.has(actionsList, action)) {
        setActions.push(actionsList[action]);
      }
    });
    return setActions;
  }

  if (!_.isEmpty(actions) && _.has(actionsList, actions)) {
    setActions.push(actionsList[actions]);
  }

  return setActions;
};

/**
 * Used to write If one action is depends on other action, then here we could configure those action details
 * Example:
 * SINGLE: delete: [{name: 'view', checked: true}, {name: 'create', checked: false}]
 * MULTIPLE: delete: [{name: ['view','create'], checked: true}, {name: ['view','create'], checked: false}]
 *
 * Above example
 * When user perform action on delete checkbox,
 * If checkbox checked, then enable 'veiw' action and If checkbox unchecked, then uncheck 'create' action.
 *
 * If user wnats to perform multiple actions change depends on one action, then write name attribute value in array format
 *
 *
 */
export const dependsOnActions = {
  delete: [
    {
      name: "view",
      checked: true
    }
  ],
  edit: [
    {
      name: "view",
      checked: true
    }
  ],
  create: [
    {
      name: "view",
      checked: true
    }
  ],
  view: [
    {
      name: ["edit", "delete", "create"],
      checked: false
    }
  ]
};

/**
 * List of management need to exclude for the super admin & other user.
 */
export const excludeManagement = {
  superAdmin: [],
  customerUsers: ["customerManagement"],
  projectUsers: [
    "customerManagement",
    "projectManagement",
    "productManagement"
  ],
  otherUsers: [
    "customerManagement",
    "projectManagement",
    "productManagement",
    "rolePermission"
  ]
};

/**
 * List of management
 *
 * Used in 'Roles & Permission' page to give permission to based on roles
 */
export const managementCollections = [
  {
    label: {"en":"Customer Onboarding", "ar":"إعداد العملاء"},
    parentObj: "customerManagement",
    actions: getActions(["create", "view", "edit", "delete"])
  },
  {
    label: {"en":"User Onboarding", "ar":"إعداد المستخدم"},
    parentObj: "userManagement",
    actions: getActions(["create", "view", "edit", "delete"])
  },
  {
    label:{"en": "Device Onboarding", "ar":"إعداد الجهاز"},
    parentObj: "deviceManagement",
    actions: getActions(["create", "view", "edit", "delete"])
  },
  {
    label:{"en":  "Device Allocation", "ar":"تخصيص الجهاز"},
    parentObj: "deviceAllocation",
    actions: getActions(["view", "assign"])
  },
  // {
  //   label: "Feeder Onboarding",
  //   parentObj: "feederManagement",
  //   actions: getActions(["create", "view", "edit", "delete"])
  // },
  // {
  //   label: "Feeder Allocation",
  //   parentObj: "feederAllocation",
  //   actions: getActions(["view", "assign"])
  // },
  {
    label:{"en": "Roles & Permissions", "ar":"الأدوار والتصاريح"},
    parentObj: "rolePermission",
    actions: getActions(["view", "create"])
  },
  {
    label:{"en":"SMS Template", "ar":"قالب SMS"},
    parentObj: "smsTemplate",
    actions: getActions(["create", "view", "edit", "delete"])
  },
  {
    label: {"en": "Address Onboarding", "ar":"العنوان على متن الطائرة"},
    parentObj: "addressManagement",
    actions: getActions(["create", "view", "edit", "delete"])
  },
  {
    label:{"en":  "Pole Onboarding", "ar":"قطب على متن الطائرة"},
    parentObj: "poleManagement",
    actions: getActions(["create", "view", "edit", "delete"])
  },
  {
    label:{"en":"Lamp Onboarding", "ar":"قطب على متن الطائرة"},
    parentObj: "lampManagement",
    actions: getActions(["create", "view", "edit", "delete"])
  },
  {
    label: {"en": "LED Load Onboarding", "ar":"تحميل على متن الطائرة LED"},
    parentObj: "ledloadManagement",
    actions: getActions(["create", "view", "edit", "delete"])
  },
  {
    label: {"en": "Product Onboarding", "ar":"إعداد المنتج"},
    parentObj: "productManagement",
    actions: getActions(["create", "view", "edit", "delete"])
  },
  {
    label: {"en": "Project Onboarding",  "ar":"إعداد المشروع"},
    parentObj: "projectManagement",
    actions: getActions(["create", "view", "edit", "delete"])
  },
  {
    label: {"en": "Device Installation Report", "ar":"تقرير تثبيت الجهاز"},
    parentObj: "deviceInstallationReport",
    actions: getActions(["view", "edit"])
  },
  // {
  //   label: "Feeder Installation Report",
  //   parentObj: "feederInstallationReport",
  //   actions: getActions(["view"])
  // },
  // {
  //   label: "Settings",
  //   parentObj: "settings",
  //   actions: getActions(["view"])
  // }
  {
    label: {"en": "Firmware Management", "ar":"تقرير تثبيت الجهاز"},
    parentObj: "firmware",
    actions: getActions(["create", "view", "edit", "delete"])
  },
  {
    label: {"en": "Frimware Update Report", "ar":"تقرير تثبيت الجهاز"},
    parentObj: "firmwareUpdateReport",
    actions: getActions(["view","edit"])
  }
];
/**
 * List of FieldEngineer Role Management
 *
 * Used in 'Roles & Permission' page to give permission to based on roles
 */
export const feRoleManagementCollections = [
  {
    label: {"en":" Device Installation", "ar":"تركيب الجهاز"},
    parentObj: "deviceInstallationManagement",
    actions: getActions(["create", "view", "edit"])
  },
  {
    label: {"en":"BLE Configuration", "ar":"إعداد المستخدم"},
    parentObj: "configurationManagement",
    actions: getActions(["view", "edit"])
  },
  {
    label:{"en": "Firmware", "ar":"إعداد الجهاز"},
    parentObj: "firmwareManagement",
    actions: getActions(["view", "edit"])
  },
  {
    label:{"en": "CLI", "ar":""},
    parentObj: "cli",
    actions: getActions(['edit'])
  }
];

/**
 * List of authorized pages to check whether each user role has permission to access or not
 */
export const authorizedPages = {
  customers: {
    create: "customerManagement.create",
    edit: "customerManagement.edit",
    delete: "customerManagement.delete",
    view: "customerManagement.view"
  },
  users: {
    create: "userManagement.create",
    edit: "userManagement.edit",
    delete: "userManagement.delete",
    view: "userManagement.view"
  },
  devices: {
    create: "deviceManagement.create",
    edit: "deviceManagement.edit",
    delete: "deviceManagement.delete",
    view: "deviceManagement.view"
  },
  deviceInventory: {
    assign: "deviceInventory.assign",
    view: "deviceInventory.view"
  },
  smsTemplate: {
    create: "smsTemplate.create",
    edit: "smsTemplate.edit",
    delete: "smsTemplate.delete",
    view: "smsTemplate.view"
  },
  rolePermission: {
    view: "rolePermission.view",
    create: "rolePermission.create"
  },
  addressManagement: {
    create: "addressManagement.create",
    edit: "addressManagement.edit",
    delete: "addressManagement.delete",
    view: "addressManagement.view"
  },
  poleManagement: {
    create: "poleManagement.create",
    edit: "poleManagement.edit",
    delete: "poleManagement.delete",
    view: "poleManagement.view"
  },
  lampManagement: {
    create: "lampManagement.create",
    edit: "lampManagement.edit",
    delete: "lampManagement.delete",
    view: "lampManagement.view"
  },
  feederManagement: {
    create: "feederManagement.create",
    edit: "feederManagement.edit",
    delete: "feederManagement.delete",
    view: "feederManagement.view"
  },
  feederAllocation: {
    assign: "feederAllocation.assign",
    view: "feederAllocation.view"
  },
  ledloadManagement: {
    create: "ledloadManagement.create",
    edit: "ledloadManagement.edit",
    delete: "ledloadManagement.delete",
    view: "ledloadManagement.view"
  },
  deviceAllocation: {
    delete: "deviceAllocation.delete",
    view: "deviceAllocation.view"
  },
  products: {
    create: "productManagement.create",
    edit: "productManagement.edit",
    delete: "productManagement.delete",
    view: "productManagement.view"
  },
  deviceInstallationReport: {
    view: "deviceInstallationReport.view",
    edit: "deviceInstallationReport.edit",
  },
  projects: {
    create: "projectManagement.create",
    edit: "projectManagement.edit",
    delete: "projectManagement.delete",
    view: "projectManagement.view"
  },
  settings: {
    view: "settings.view"
  },
  firmware:{
    create: "firmware.create",
    edit: "firmware.edit",
    delete: "firmware.delete",
    view: "firmware.view"
  },
  firmwareUpdateReport:{
    view: "firmwareUpdateReport.view",
    edit: "firmwareUpdateReport.edit",
  }
};
